import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import moment from "moment";
import React from "react";

export default function PromotionCalendarDialog(props) {
  const {
    onCancel,
    open,
    onSubmit,
    onDelete,
    submitMessage,
    deleteMessage,
    actions,
    handleOnChange,
    event,
    submitButtonColor = "primary",
  } = props;

  React.useEffect(() => {}, []);
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle>{moment(event.date).format("YYYY-MM-DD")}</DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <DialogContentText>
          <Box
            component="form"
            noValidate
            sx={{
              display: "grid",
              gap: 2,
            }}
          >
            <FormControl fullWidth>
              <TextField
                value={event.title}
                label="名稱"
                onChange={(e) => handleOnChange(e.target.value, "title")}
              ></TextField>
            </FormControl>
            <FormControl>
              <FormControlLabel
                control={
                  <Switch
                    checked={event.allow_redeem}
                    onChange={(e) =>
                      handleOnChange(e.target.checked, "allow_redeem")
                    }
                  />
                }
                label="預約換領贈品"
              />
            </FormControl>
          </Box>
        </DialogContentText>
      </DialogContent>
      {actions?.manage && (
        <DialogActions>
          {!event.isNew && (
            <Button onClick={onDelete} color={"error"} type="submit">
              {deleteMessage}
            </Button>
          )}
          <Button onClick={onSubmit} color={submitButtonColor} type="submit">
            {submitMessage}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
